<template>
    <div>
        <div class="card shadow-sm">
            <div class="card-body">
                <static-loading-indicator-icon :loading="$store.getters.shouldLoadLocal"/>
                <div v-if="!$store.getters.shouldLoadLocal">
                    <h3 class="card-title">{{ $t('pages.subscription.start.questions.title') }}</h3>
                    <p class="card-text" v-html="$t('pages.subscription.start.questions.safety_text')"></p>

                    <hr>

<!--                    <div class="mb-4">-->
<!--                        <h5 class="font-weight-lighter">{{ $t('pages.subscription.start.questions.goal.my_goal') }}</h5>-->

<!--                        <div class="form-check-inline">-->
<!--                            <label class="form-check-label">-->
<!--                                <input type="radio" class="form-check-input" v-model="goal" value="health">-->
<!--                                {{ $t('pages.subscription.start.questions.goal.goal_health') }}-->
<!--                                <i class="input-helper"></i>-->
<!--                            </label>-->
<!--                        </div>-->
<!--                        <div class="form-check-inline">-->
<!--                            <label class="form-check-label">-->
<!--                                <input type="radio" class="form-check-input" v-model="goal" value="fitness">-->
<!--                                {{ $t('pages.subscription.start.questions.goal.goal_fitness') }}-->
<!--                                <i class="input-helper"></i>-->
<!--                            </label>-->
<!--                        </div>-->
<!--                        <div class="form-check-inline">-->
<!--                            <label class="form-check-label">-->
<!--                                <input type="radio" class="form-check-input" v-model="goal" value="performance">-->
<!--                                {{ $t('pages.subscription.start.questions.goal.goal_performance') }}-->
<!--                                <i class="input-helper"></i>-->
<!--                            </label>-->
<!--                        </div>-->
<!--                        <div class="form-check-inline">-->
<!--                            <label class="form-check-label">-->
<!--                                <input type="radio" class="form-check-input" v-model="goal" value="other">-->
<!--                                {{ $t('pages.subscription.start.questions.goal.goal_other') }}-->
<!--                                <i class="input-helper"></i>-->
<!--                            </label>-->
<!--                        </div>-->

<!--                        <hr>-->
<!--                    </div>-->

                    <div v-for="(question, i) in questions" :key="i" class="mt-4">
                        <h5 class="font-weight-lighter">
                            {{ question.text }}
                        </h5>

                        <div class="form-check-inline">
                            <label class="form-check-label">
                                <input type="radio" class="form-check-input" v-model="question.answer" :value="true">
                                {{ $t('pages.subscription.start.questions.answer_yes') }}
                                <i class="input-helper"></i>
                            </label>
                        </div>

                        <div class="form-check-inline">
                            <label class="form-check-label">
                                <input type="radio" class="form-check-input" v-model="question.answer" :value="false">
                                {{ $t('pages.subscription.start.questions.answer_no') }}
                                <i class="input-helper"></i>
                            </label>
                        </div>

                        <hr>
                    </div>

                    <div class="alert alert-secondary border-dark shadow-sm mt-5 mb-5">
                        <p class="card-text" v-html="$t('pages.subscription.start.questions.safety_bottom_text')"></p>
                    </div>


                    <button class="btn btn-outline-dark" @click="saveAnswers" :disabled="!hasAnsweredAllQuestions" :class="{'btn-disabled': !hasAnsweredAllQuestions}">
                        {{ $t('actions.update') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubscriptionStartRepository from "../../../repositories/Subscription/SubscriptionStartRepository";
import AccountRepository from "../../../repositories/Account/AccountRepository";
import StaticLoadingIndicatorIcon from "../../Includes/StaticLoadingIndicatorIcon";

export default {
    name: "AccountUpdateHealthQuestions",
    components: {StaticLoadingIndicatorIcon},
    data: () => ({
        goal: null,
        questions: [
            { answer: null,     text: '' },
            { answer: null,     text: '' },
            { answer: null,     text: '' },
            { answer: null,     text: '' },
            { answer: null,     text: '' },
            { answer: null,     text: '' },
            { answer: null,     text: '' },
        ]
    }),
    mounted() {
        this.questions[0].text = this.$t('pages.subscription.start.questions.question_one');
        this.questions[1].text = this.$t('pages.subscription.start.questions.question_two');
        this.questions[2].text = this.$t('pages.subscription.start.questions.question_three');
        this.questions[3].text = this.$t('pages.subscription.start.questions.question_four');
        this.questions[4].text = this.$t('pages.subscription.start.questions.question_five');
        this.questions[5].text = this.$t('pages.subscription.start.questions.question_six');
        this.questions[6].text = this.$t('pages.subscription.start.questions.question_seven');

        AccountRepository.getQuestionAnswers().then((res) => {
            this.goal = res.data.goal;

            let answers = res.data.answers;
            answers.forEach((a, i) => this.questions[i].answer = !!a);
        })
    },
    computed: {
        hasAnsweredAllQuestions() {
            return this.questions.every(q => q.answer !== null) && this.goal !== null;
        }
    },
    methods: {
        saveAnswers() {
            if(!this.hasAnsweredAllQuestions) {
                this.$snotify.error(this.$t('pages.subscription.start.questions.please_answer_all'));
                return false;
            }

            AccountRepository.updateQuestionAnswers({
                questions: this.questions,
                goal: this.goal
            }).then((res) => this.$snotify.success(this.$t('actions.updated')));
        }
    },
}
</script>

<style scoped>

</style>
